import { chartAxes } from '../../constants/event';
import { sortingOptions, sortingOrder } from '../../constants/common';
import { getView, getViews } from '../../utils/event/common';
import { EVENT_TEMPLATE_TYPE } from '../../constants/dashboards';

const columnChartSortingInitialState = {
  axis: chartAxes.Y,
  order: sortingOrder.DESCENDING,
  sortingOptions: sortingOptions.INDEPEND,
};

export const executeEventOptions = {
  columnChartSorting: columnChartSortingInitialState,
  views: [],
  view: undefined,
  singleChartMode: true,
  showFormula: false,
  calcTotal: false,
  averageLine: false,
  medianLine: false,
  trendLine: false,
  showSortingOptions: false,
  enteredFormula: null,
  adaptive: false,
  cumulative: false,
};

const executeInitialState = {
  events: null,
  executeTime: 0,
  options: executeEventOptions,
  executing: false,
  executeId: '',
};

const execute = (state = executeInitialState, action) => {
  switch (action.type) {
    case 'EXECUTE_EVENT_QUERIES_SUCCESS':
      return {
        ...state,
        executeTime: new Date().valueOf(),
        events: action.result,
        executing: false,
        executeId: '',
        options: {
          ...state.options,
          ...action.options,
          view: getView(state.options.view, action.result),
          views: getViews(action.result, state.options.eventSort),
          showFormula: false,
          showSortingOptions: state.options.singleChartMode ? false : action.result.length > 1,
          enteredFormula: null,
        },
      };

    case 'EXECUTE_EVENT_QUERIES_FAILURE':
      return {
        ...state,
        executing: false,
        executeId: '',
      };

    case 'EXECUTE_EVENT_QUERIES':
      return {
        ...state,
        executing: true,
      };

    case 'SET_EVENT_EXECUTE_ID':
      return {
        ...state,
        executeId: action.executeId,
      };

    case 'CHANGE_EVENT_VIEW':
      return {
        ...state,
        options: {
          ...state.options,
          view: action.view,
        },
      };

    case 'CHANGE_EVENT_COLUMN_CHART_SORTING':
      return {
        ...state,
        options: {
          ...state.options,
          columnChartSorting: action.sorting,
        },
      };

    case 'EVENT_EXECUTE_SET_CHART_MODE':
      return {
        ...state,
        options: {
          ...state.options,
          singleChartMode: action.single,
          showSortingOptions: state.options.enteredFormula === null ? !action.single : true,
        },
      };

    case 'TOGGLE_EVENTS_CALC_TOTAL':
      return {
        ...state,
        options: {
          ...state.options,
          calcTotal: !state.options.calcTotal,
        },
      };

    case 'TOGGLE_EVENTS_TREND_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          trendLine: !state.options.trendLine,
        },
      };

    case 'TOGGLE_EVENTS_AVERAGE_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          averageLine: !state.options.averageLine,
        },
      };

    case 'TOGGLE_EVENTS_MEDIAN_LINE':
      return {
        ...state,
        options: {
          ...state.options,
          medianLine: !state.options.medianLine,
        },
      };

    case 'TOGGLE_EVENTS_ADAPTIVE':
      return {
        ...state,
        options: {
          ...state.options,
          adaptive: !state.options.adaptive,
        },
      };

    case 'TOGGLE_EVENTS_CUMULATIVE':
      return {
        ...state,
        options: {
          ...state.options,
          cumulative: !state.options.cumulative,
        },
      };

    case 'EVENT_CHANGE_VISIBLE_FORMULA':
      return {
        ...state,
        options: {
          ...state.options,
          showFormula: !state.options.showFormula,
        },
      };

    case 'EVENT_ENTER_FORMULA':
      return {
        ...state,
        options: {
          ...state.options,
          enteredFormula: action.enteredFormula,
          showSortingOptions: true,
        },
      };

    case 'EVENT_SET_EXPAND':
      return {
        ...state,
        options: {
          ...state.options,
          isExpand: action.value,
        },
      };

    case `SET_TEMPLATE_${EVENT_TEMPLATE_TYPE}`:
      return {
        ...executeInitialState,
        options: {
          ...executeInitialState.options,
          columnChartSorting: {
            ...state.options.columnChartSorting,
            axis: action.template.sortingAxis,
            order: action.template.sortingOrder,
          },
          singleChartMode: action.template.multiqueryMode === 'SINGLE',
          showFormula: action.template.formula === null,
          calcTotal: action.template.showGrandTotal,
          averageLine: action.template.showAverage,
          medianLine: action.template.showMedian,
          enteredFormula: action.template.formula,
          showSortingOptions: true,
        },
      };

    case `SET_RESULT_${EVENT_TEMPLATE_TYPE}`:
      return {
        ...state,
        executeTime: new Date().valueOf(),
        events: action.templateResult.result,
        options: {
          ...state.options,
          ...action.templateResult.options,
          view: getView(state.options.view, action.templateResult.result),
          views: getViews(action.templateResult.result),
        },
      };

    default:
      return state;
  }
};

export default execute;

export const getEvents = (state) => state.events;

export const getExecuteTime = (state) => state.executeTime;

export const getEventsOptions = (state) => state.options;

export const isExecuting = (state) => state.executing;

export const getExecuteId = (state) => state.executeId;
